// `/backend/config` decides whether the Picklist / Droplist routes and menu
// entries are registered at all. Redux here is in-memory only, so without a
// cache every reload starts with those features reading "off" until the
// request resolves — a window long enough for the router to 404 a deep link
// like /picklist-table and bounce the user to /bills. The last known-good
// config is cached here and seeds the reducer's initial state. It is wiped
// with everything else by the localStorage.clear() in logout.
export const BACKEND_CONFIG_KEY = "BackendConfig";

export const readCachedBackendConfig = () => {
  try {
    const raw = localStorage.getItem(BACKEND_CONFIG_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    return {};
  }
};

export const cacheBackendConfig = (config) => {
  try {
    localStorage.setItem(BACKEND_CONFIG_KEY, JSON.stringify(config));
  } catch (error) {
    // Storage full or blocked — the in-session flags still work, only the
    // no-flicker-on-reload part is lost.
  }
};

// Only an explicit value from the backend may flip a flag. A missing key
// (partial payload, reshaped response) returns undefined so the caller keeps
// the previous value instead of reading the gap as "disabled". Strings and
// 0/1 are tolerated because the config table has served both.
export const readConfigFlag = (raw) => {
  if (raw === undefined || raw === null) return undefined;
  if (typeof raw === "string") {
    const normalized = raw.trim().toLowerCase();
    if (normalized === "") return undefined;
    return normalized === "true" || normalized === "1";
  }
  return Boolean(raw);
};
